import { PLAYERS_MOBILE_LABEL_MAX } from '../pages/newResults/newResultsConstants';

export const TEAM_SORT_TOTAL = 'total';
export const TEAM_SORT_QUILLES = 'quilles';
export const TEAM_SORT_AVERAGE = 'average';
export const PLAYER_SORT_QUILLES = 'quilles';
export const PLAYER_SORT_AVERAGE = 'average';

export function truncateDisplayLabel(text, maxLength = PLAYERS_MOBILE_LABEL_MAX) {
	if (!text) return '';
	return String(text).trim().slice(0, maxLength);
}

function getTeamRowPartyCount(row) {
	return Number(row.totalParties ?? row.parties ?? row.teamPartyCount ?? 0);
}

function allTeamsHaveSamePartyCount(rows) {
	if (rows.length <= 1) return true;
	const reference = getTeamRowPartyCount(rows[0]);
	return rows.every((row) => getTeamRowPartyCount(row) === reference);
}

/** Même nb de parties → total/quilles ; sinon → moyenne/partie. */
export function resolveAutoTeamSortColumn(rows, { isRoundView = false } = {}) {
	if (allTeamsHaveSamePartyCount(rows)) {
		return isRoundView ? TEAM_SORT_QUILLES : TEAM_SORT_TOTAL;
	}
	return TEAM_SORT_AVERAGE;
}

function compareTeamRowsForSort(a, b, sortColumn) {
	if (sortColumn === TEAM_SORT_AVERAGE) {
		const avgDiff = (Number(b.totalAverage ?? b.average) || 0) - (Number(a.totalAverage ?? a.average) || 0);
		if (avgDiff !== 0) return avgDiff;
	} else if (sortColumn === TEAM_SORT_QUILLES) {
		const quillesDiff = (Number(b.quilles) || 0) - (Number(a.quilles) || 0);
		if (quillesDiff !== 0) return quillesDiff;
	} else {
		const totalDiff = (Number(b.totalQuilles) || 0) - (Number(a.totalQuilles) || 0);
		if (totalDiff !== 0) return totalDiff;
	}
	return (a.teamName || '').localeCompare(b.teamName || '', 'fr');
}

export function sortTeamRankingRows(rows, sortColumn) {
	return [...rows]
		.sort((a, b) => compareTeamRowsForSort(a, b, sortColumn))
		.map((row, index) => ({ ...row, rank: index + 1 }));
}

export function sortPlayerRows(players, sortColumn) {
	return [...players].sort((a, b) => {
		if (sortColumn === PLAYER_SORT_AVERAGE) {
			const avgDiff = (Number(b.average) || 0) - (Number(a.average) || 0);
			if (avgDiff !== 0) return avgDiff;
		} else {
			const quillesDiff = (Number(b.quilles) || 0) - (Number(a.quilles) || 0);
			if (quillesDiff !== 0) return quillesDiff;
		}
		return (a.playerName || '').localeCompare(b.playerName || '', 'fr');
	});
}
